export const bgWhiteIcons = [
 {
  icon: ['fab', 'facebook-f'],
  color: 'facebook',
  bg: 'white',
  href: 'https://www.facebook.com/',
  target: '_blank'
 },
 {
  icon: ['fab', 'twitter'],
  color: 'twitter',
  bg: 'white',
  href: 'https://www.twitter.com/',
  target: '_blank'
 },
 {
  icon: ['fab', 'instagram'],
  color: 'instagram',
  bg: 'white',
  href: 'https://www.instagram.com/',
  target: '_blank'
 },
 {
  icon: ['fab', 'linkedin-in'],
  color: 'linkedin',
  bg: 'white',
  href: 'https://co.linkedin.com/',
  target: '_blank'
 }
];
export default [
 { icon: ['fab', 'facebook-f'], color: 'facebook', href: '#!' },
 { icon: ['fab', 'twitter'], color: 'twitter', href: '#!' },
 {
  icon: ['fab', 'instagram'],
  color: 'instagram',
  href: '#!'
 },
 { icon: ['fab', 'linkedin-in'], color: 'linkedin', href: '#!' }
];
